(function () {
  var appliedCode = null;

  async function fitzApplyDiscount() {
    var discountEl = document.querySelector('.fitz-discount');
    if (!discountEl) return;

    var input = document.getElementById('CartDrawer-DiscountCode');
    var msg = document.getElementById('fitz-discount-msg');
    if (!input || !msg) return;

    var code = input.value.trim().toUpperCase();
    if (!code) return;

    var shopDomain = window.location.hostname;
    var sfToken = discountEl.dataset.token;
    var flatShippingRate = parseFloat(discountEl.dataset.shippingRate || 5);
    var freeShippingThreshold = parseFloat(discountEl.dataset.threshold || 75);
    var decalFee = parseFloat(discountEl.dataset.decalFee || 4);

    msg.textContent = 'Checking...';
    msg.className = 'fitz-discount__msg';

    try {
      var cartRes = await fetch('/cart.js');
      var cart = await cartRes.json();

      if (!cart.items.length) {
        msg.textContent = 'Your cart is empty.';
        return;
      }

      var lines = cart.items.map(function (item) {
        return {
          merchandiseId: 'gid://shopify/ProductVariant/' + item.variant_id,
          quantity: item.quantity
        };
      });

      var query = 'mutation cartCreate($input: CartInput!) { cartCreate(input: $input) { cart { discountCodes { code applicable } cost { totalAmount { amount } } } userErrors { code field message } } }';

      var sfRes = await fetch('https://' + shopDomain + '/api/2025-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': sfToken
        },
        body: JSON.stringify({
          query: query,
          variables: { input: { lines: lines, discountCodes: [code] } }
        })
      });

      var data = await sfRes.json();
      var result = data.data.cartCreate;

      if (result.userErrors && result.userErrors.length) {
        var merchandiseErr = result.userErrors.some(function (e) {
          return e.field && e.field.join(',').indexOf('merchandiseId') !== -1;
        });
        if (merchandiseErr) {
          msg.textContent = 'Something went wrong. Try again.';
        } else {
          msg.textContent = 'Invalid code. Please try again.';
        }
        msg.className = 'fitz-discount__msg fitz-discount__msg--error';
        return;
      }

      var discountCode = result.cart.discountCodes[0];

      if (!discountCode || !discountCode.applicable) {
        msg.textContent = 'Code not valid or already used.';
        msg.className = 'fitz-discount__msg fitz-discount__msg--error';
        return;
      }

      var originalSubtotal = cart.total_price / 100;
      var discountedSubtotal = parseFloat(result.cart.cost.totalAmount.amount);
      var savings = originalSubtotal - discountedSubtotal;

      // Decals ship separately at a flat fee and don't count toward the apparel free-shipping threshold
      var hasDecal = cart.items.some(function (item) {
        return item.product_type === 'Sticker' || item.product_type === 'Stickers';
      });
      var hasApparel = cart.items.some(function (item) {
        return item.product_type !== 'Sticker' && item.product_type !== 'Stickers';
      });
      var decalSubtotal = cart.items.reduce(function (sum, item) {
        var isDecal = item.product_type === 'Sticker' || item.product_type === 'Stickers';
        return isDecal ? sum + item.final_line_price / 100 : sum;
      }, 0);
      // Approximate apparel-only post-discount subtotal (assumes the code isn't decal-specific)
      var apparelSubtotal = discountedSubtotal - decalSubtotal;

      // Recalculate shipping based on discounted subtotal (no apparel in cart = no apparel shipping fee)
      var apparelShipping = !hasApparel ? 0 : (apparelSubtotal >= freeShippingThreshold ? 0 : flatShippingRate);
      var effectiveShipping = apparelShipping + (hasDecal ? decalFee : 0);
      var newEstTotal = discountedSubtotal + effectiveShipping;

      if (savings > 0) {
        var subtotalValue = document.getElementById('fitz-subtotal-value');
        var discountRow = document.getElementById('fitz-discount-row');
        var discountLabel = document.getElementById('fitz-discount-row-label');
        var discountValue = document.getElementById('fitz-discount-row-value');
        var estTotalValue = document.getElementById('fitz-est-total-value');
        var shippingValue = document.getElementById('fitz-shipping-value');
        var freeShippingMsg = document.getElementById('fitz-free-shipping-msg');

        // Update subtotal to show discounted price
        if (subtotalValue) subtotalValue.innerHTML = '<s style="opacity:0.4">$' + originalSubtotal.toFixed(2) + ' USD</s> $' + discountedSubtotal.toFixed(2) + ' USD';

        // Show discount row
        if (discountRow) discountRow.style.display = '';
        if (discountLabel) discountLabel.textContent = code;
        if (discountValue) discountValue.textContent = '-$' + savings.toFixed(2);

        // Update shipping display based on discounted total
        if (shippingValue) {
          if (effectiveShipping === 0) {
            shippingValue.textContent = 'Free';
            shippingValue.className = 'totals__total-value fitz-shipping-free';
          } else {
            shippingValue.textContent = '$' + effectiveShipping.toFixed(2);
            shippingValue.className = 'totals__total-value';
          }
        }

        // Update estimated total
        if (estTotalValue) estTotalValue.textContent = '$' + newEstTotal.toFixed(2) + ' USD';

        // Update free shipping message
        if (freeShippingMsg) {
          if (!hasApparel && hasDecal) {
            freeShippingMsg.innerHTML = 'Decals ship for a flat <strong>$' + decalFee.toFixed(0) + '</strong>.';
          } else if (apparelSubtotal >= freeShippingThreshold) {
            freeShippingMsg.innerHTML = hasDecal
              ? "You've unlocked <strong>Free Shipping</strong> on apparel — decals ship for a flat <strong>$" + decalFee.toFixed(0) + "</strong>."
              : "You've unlocked <strong>Free Shipping!</strong>";
          } else {
            var remaining = (freeShippingThreshold - apparelSubtotal).toFixed(0);
            freeShippingMsg.innerHTML = 'Only <strong>$' + remaining + '</strong> away from <strong>Free Shipping!</strong>' + (hasDecal ? ' (decals still ship for a flat $' + decalFee.toFixed(0) + ')' : '');
          }
        }
      }

      // Store code so checkout redirect can carry it through
      appliedCode = code;
      try { localStorage.setItem('fitzDiscountCode', code); } catch(e) {}

      msg.textContent = '';
      msg.className = 'fitz-discount__msg';

    } catch (err) {
      msg.textContent = 'Something went wrong. Try again.';
      msg.className = 'fitz-discount__msg fitz-discount__msg--error';
    }
  }

  // Remove applied discount code
  async function fitzRemoveDiscount() {
    appliedCode = null;
    try { localStorage.removeItem('fitzDiscountCode'); } catch(e) {}

    var input = document.getElementById('CartDrawer-DiscountCode');
    if (input) input.value = '';

    var msg = document.getElementById('fitz-discount-msg');
    if (msg) { msg.textContent = ''; msg.className = 'fitz-discount__msg'; }

    // Try to clear native Shopify cart discount
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      });
    } catch(e) {}

    // Restore original (pre-discount) cart totals
    try {
      var cartRes = await fetch('/cart.js');
      var cart = await cartRes.json();
      // items_subtotal_price is pre-discount; fall back to total_price if not available
      var originalSubtotal = (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price) / 100;
      var flatShippingRate = 5;
      var freeShippingThreshold = 75;
      var decalFee = 4;
      var discountEl = document.querySelector('.fitz-discount');
      if (discountEl) {
        flatShippingRate = parseFloat(discountEl.dataset.shippingRate || 5);
        freeShippingThreshold = parseFloat(discountEl.dataset.threshold || 75);
        decalFee = parseFloat(discountEl.dataset.decalFee || 4);
      }
      var hasDecal = cart.items.some(function (item) {
        return item.product_type === 'Sticker' || item.product_type === 'Stickers';
      });
      var hasApparel = cart.items.some(function (item) {
        return item.product_type !== 'Sticker' && item.product_type !== 'Stickers';
      });
      var decalSubtotal = cart.items.reduce(function (sum, item) {
        var isDecal = item.product_type === 'Sticker' || item.product_type === 'Stickers';
        return isDecal ? sum + item.original_line_price / 100 : sum;
      }, 0);
      var apparelSubtotal = originalSubtotal - decalSubtotal;
      var apparelShipping = !hasApparel ? 0 : (apparelSubtotal >= freeShippingThreshold ? 0 : flatShippingRate);
      var shipping = apparelShipping + (hasDecal ? decalFee : 0);
      var estTotal = originalSubtotal + shipping;

      var subtotalValue = document.getElementById('fitz-subtotal-value');
      if (subtotalValue) subtotalValue.textContent = '$' + originalSubtotal.toFixed(2) + ' USD';

      var discountRow = document.getElementById('fitz-discount-row');
      if (discountRow) discountRow.style.display = 'none';

      var shippingValue = document.getElementById('fitz-shipping-value');
      if (shippingValue) {
        if (shipping === 0) {
          shippingValue.textContent = 'Free';
          shippingValue.className = 'totals__total-value fitz-shipping-free';
        } else {
          shippingValue.textContent = '$' + shipping.toFixed(2);
          shippingValue.className = 'totals__total-value';
        }
      }

      var estTotalValue = document.getElementById('fitz-est-total-value');
      if (estTotalValue) estTotalValue.textContent = '$' + estTotal.toFixed(2) + ' USD';

      var freeShippingMsg = document.getElementById('fitz-free-shipping-msg');
      if (freeShippingMsg) {
        if (!hasApparel && hasDecal) {
          freeShippingMsg.innerHTML = 'Decals ship for a flat <strong>$' + decalFee.toFixed(0) + '</strong>.';
        } else if (apparelSubtotal >= freeShippingThreshold) {
          freeShippingMsg.innerHTML = hasDecal
            ? "You've unlocked <strong>Free Shipping</strong> on apparel — decals ship for a flat <strong>$" + decalFee.toFixed(0) + "</strong>."
            : "You've unlocked <strong>Free Shipping!</strong>";
        } else {
          var remaining = (freeShippingThreshold - apparelSubtotal).toFixed(0);
          freeShippingMsg.innerHTML = 'Only <strong>$' + remaining + '</strong> away from <strong>Free Shipping!</strong>' + (hasDecal ? ' (decals still ship for a flat $' + decalFee.toFixed(0) + ')' : '');
        }
      }
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'fitz-discount-remove') {
      fitzRemoveDiscount();
    }
  });

  // Intercept checkout form submit — redirect to /checkout?discount=CODE
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.id === 'CartDrawer-Form' && appliedCode && e.submitter && e.submitter.name === 'checkout') {
      e.preventDefault();
      window.location.href = '/checkout?discount=' + encodeURIComponent(appliedCode);
    }
  });

  // Smart upsell — same design, different apparel
  async function fitzLoadUpsell() {
    var container = document.getElementById('fitz-upsell-container');
    if (!container) return;

    try {
      var results = await Promise.all([
        fetch('/cart.js').then(function (r) { return r.json(); }),
        Promise.all([
          fetch('/products.json?limit=250&page=1').then(function (r) { return r.json(); }),
          fetch('/products.json?limit=250&page=2').then(function (r) { return r.json(); })
        ]).then(function (pages) {
          return { products: pages[0].products.concat(pages[1].products) };
        })
      ]);
      var cart = results[0];
      var allProducts = results[1].products;

      if (!cart.items.length) { container.innerHTML = ''; return; }

      // Group similar apparel types so hoodie won't upsell sweatshirt and vice versa
      var typeGroupMap = {
        'Hoodie': 'warm',
        'Sweatshirt': 'warm',
        'Crewneck': 'warm',
        'Crewneck Sweatshirt': 'warm',
        'Pullover': 'warm',
        'T-Shirt': 'tee',
        'Back Print': 'tee',
        'Heavyweight T-Shirt': 'tee',
        'Tank Top': 'tee',
        'V-neck': 'tee',
        'Tee': 'tee',
        'Hats': 'hat',
        'Sticker': 'sticker',
        'Stickers': 'sticker',
        'Paper products': 'sticker',
      };

      function getTypeGroup(type) {
        return typeGroupMap[type] || type;
      }

      var cartProductIds = {};
      var cartExactTypes = {};  // exact product_type strings in cart
      var cartTypeGroups = {};  // type groups in cart (for tee/hat grouping)
      var cartDesignTags = {};

      cart.items.forEach(function (item) {
        cartProductIds[item.product_id] = true;

        // Use product_type directly from cart — more reliable than a lookup
        if (item.product_type) {
          cartExactTypes[item.product_type] = true;
          cartTypeGroups[getTypeGroup(item.product_type)] = true;
        }

        // Still look up in allProducts for design tags (cart.js doesn't include tags)
        var match = allProducts.find(function (p) { return p.id === item.product_id; });
        if (match) {
          cartExactTypes[match.product_type] = true;
          cartTypeGroups[getTypeGroup(match.product_type)] = true;
          match.tags.forEach(function (tag) {
            if (tag.indexOf('design:') === 0) cartDesignTags[tag] = true;
          });
        }
      });

      if (!Object.keys(cartDesignTags).length) { container.innerHTML = ''; return; }

      // Filter by type group — any warm top in cart blocks all other warm tops
      function isAlreadyInCart(productType) {
        return !!cartTypeGroups[getTypeGroup(productType)];
      }

      // Hat types get first priority in upsell slot
      function isHat(type) { return getTypeGroup(type) === 'hat'; }

      // Collect upsell candidates:
      // - One per product_type per design (warm tops get individual slots for hoodie + sweatshirt)
      // - Other categories get one slot per design
      // - Hats get top priority
      var seenKeys = {};
      var candidates = [];

      for (var i = 0; i < allProducts.length; i++) {
        var p = allProducts[i];
        if (cartProductIds[p.id]) continue;
        if (p.product_type === 'Archived') continue; // suppress unlisted/old products from upsell
        if (isAlreadyInCart(p.product_type)) continue;

        var matchedDesign = null;
        for (var j = 0; j < p.tags.length; j++) {
          if (cartDesignTags[p.tags[j]]) { matchedDesign = p.tags[j]; break; }
        }
        if (!matchedDesign) continue;

        // Warm group: one slot per product_type (hoodie + sweatshirt each get a card)
        // All others: one slot per design group
        var group = getTypeGroup(p.product_type);
        var slotKey = matchedDesign + '|' + (group === 'warm' ? p.product_type : group);
        if (seenKeys[slotKey]) continue;
        seenKeys[slotKey] = true;
        candidates.push(p);
      }

      // Sort: hats first, stickers second, warm tops third, everything else after
      function sortRank(p) {
        var g = getTypeGroup(p.product_type);
        if (isHat(p.product_type)) return 0;
        if (g === 'sticker') return 1;
        if (g === 'warm') return 2;
        return 3;
      }
      candidates.sort(function(a, b) { return sortRank(a) - sortRank(b); });

      // If cart already covers all 3 major categories, skip to explore
      var allCategoriesCovered = cartTypeGroups['hat'] && cartTypeGroups['tee'] && cartTypeGroups['warm'];
      var upsells = allCategoriesCovered ? [] : candidates.slice(0, 3);
      var isExploreFallback = false;

      // Fallback: use Shopify's recommendation engine (collection-aware) for each cart product
      if (!upsells.length) {
        var shownFallbackIds = {};
        var shownFallbackDesigns = {};
        var cartItemIds = cart.items.map(function(i) { return i.product_id; });

        var recResults = await Promise.all(
          cartItemIds.map(function(pid) {
            return fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=related')
              .then(function(r) { return r.json(); })
              .catch(function() { return { products: [] }; });
          })
        );

        recResults.forEach(function(res) {
          res.products.forEach(function(fp) {
            if (upsells.length >= 3) return;
            if (cartProductIds[fp.id] || shownFallbackIds[fp.id]) return;
            if (fp.product_type === 'Archived') return; // suppress unlisted/old products from upsell fallback
            var fpDesigns = (fp.tags || []).filter(function(t) { return t.indexOf('design:') === 0; });
            var hasCartDesign = fpDesigns.some(function(t) { return cartDesignTags[t]; });
            if (hasCartDesign) return;
            var fpDesign = fpDesigns[0] || ('id:' + fp.id);
            if (shownFallbackDesigns[fpDesign]) return;
            shownFallbackDesigns[fpDesign] = true;
            shownFallbackIds[fp.id] = true;
            upsells.push(fp);
          });
        });

        if (upsells.length) isExploreFallback = true;
      }

      if (!upsells.length) { upsellPopulating = true; container.innerHTML = ''; setTimeout(function () { upsellPopulating = false; }, 500); return; }

      var cards = upsells.map(function (u) {
        var img = (u.images && u.images[0] && (u.images[0].src || u.images[0])) || u.featured_image || '';
        if (img && typeof img === 'object') img = img.src || '';
        var rawPrice = (u.variants && u.variants[0] && u.variants[0].price) || u.price || 0;
        // products.json returns "28.00" (dollars), recommendations API returns 2800 (cents)
        var priceNum = (typeof rawPrice === 'string' && rawPrice.indexOf('.') !== -1)
          ? parseFloat(rawPrice)
          : parseFloat(rawPrice) / 100;
        var price = priceNum ? '$' + priceNum.toFixed(2) : '';
        return '<a href="/products/' + u.handle + '" class="fitz-upsell__item">' +
          '<div class="fitz-upsell__img-wrap">' +
          (img ? '<img class="fitz-upsell__img" src="' + img + '" alt="' + u.title + '" loading="lazy">' : '') +
          '<span class="fitz-upsell__add">+</span>' +
          '</div>' +
          '<p class="fitz-upsell__name">' + u.title + '</p>' +
          '<p class="fitz-upsell__price">' + price + '</p>' +
          '</a>';
      }).join('');

      var heading = isExploreFallback ? 'Explore more designs' : 'Complete the fit';

      upsellPopulating = true;
      container.innerHTML =
        '<div class="fitz-upsell">' +
        '<p class="fitz-upsell__heading">' + heading + '</p>' +
        '<div class="fitz-upsell__grid">' + cards + '</div>' +
        '</div>';
      setTimeout(function () { upsellPopulating = false; }, 500);

    } catch (e) {
      // Silently fail — upsell is non-critical
    }
  }

  // Restore persisted discount code — safe to call after every cart re-render
  var discountRestoring = false;
  function fitzRestoreDiscount() {
    var saved;
    try { saved = localStorage.getItem('fitzDiscountCode'); } catch(e) {}
    if (!saved || discountRestoring) return;
    var input = document.getElementById('CartDrawer-DiscountCode');
    if (!input) return;
    discountRestoring = true;
    input.value = saved;
    fitzApplyDiscount().finally(function () { discountRestoring = false; });
  }

  // Re-run upsell + discount restore whenever #CartDrawer re-renders
  var cartDrawerEl = document.getElementById('CartDrawer');
  if (cartDrawerEl) {
    var upsellTimer;
    var upsellPopulating = false;
    new MutationObserver(function () {
      if (upsellPopulating || discountRestoring) return;
      clearTimeout(upsellTimer);
      upsellTimer = setTimeout(function () {
        fitzLoadUpsell();
        fitzRestoreDiscount();
      }, 300);
    }).observe(cartDrawerEl, { childList: true, subtree: true });
  }

  // Also run on initial page load
  fitzLoadUpsell();
  fitzRestoreDiscount();

  // Event delegation — survives innerHTML re-renders of #CartDrawer
  document.addEventListener('click', function (e) {
    if (e.target && e.target.classList.contains('fitz-discount__button')) {
      fitzApplyDiscount();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.target && e.target.id === 'CartDrawer-DiscountCode' && e.key === 'Enter') {
      fitzApplyDiscount();
    }
  });
})();
